import { ReactNode } from 'react';

import GoBack from '../../components/go-back/go-back';
import Toggle from '../../components/toggle/toggle';
import Divider from '../../components/divider/divider';
import ButtonKey from '../../components/button-key/button-key';
import View from '../../components/view/view';
import { useSettingsStore } from '../../store/settings-store';

import styles from './settings.module.scss';
import ThemeSelection from './theme-selection';

const SettingsView = () => {
    const {
        shortcuts,
        menuCollapsable,
        toggleMenuCollapsable,
        theme,
        sendOnEnter,
        toggleSendOnEnter,
    } = useSettingsStore();

    const renderShortcuts = (): ReactNode[] => {
        return shortcuts.map((shortcut, idx) => (
            <div key={idx} className={styles.shortcutRow}>
                <span>{shortcut.displayText} →</span>
                {shortcut.keys.map((key, idx) => (
                    <div
                        key={idx}
                        className={'flex align-center'}
                        style={{ gap: 4 }}
                    >
                        <ButtonKey>{key}</ButtonKey>
                        {idx !== shortcut.keys.length - 1 && <span>+</span>}
                    </div>
                ))}
            </div>
        ));
    };

    return (
        <View theme={theme}>
            <div className="viewContent">
                <header>
                    <GoBack theme={theme.current} />
                    <h1 className={styles.title}>Ajustes</h1>
                </header>
                <section className={styles.content}>
                    <div className={styles.toggles}>
                        <div className={styles.row}>
                            <span>Hacer el menú desplegable</span>
                            <Toggle
                                default={menuCollapsable}
                                onToggle={toggleMenuCollapsable}
                            />
                        </div>
                        <div className={styles.col}>
                            <span>Tema (color de la interfaz)</span>
                            <ThemeSelection
                                onSelect={theme.change}
                                defaultValue={theme.current}
                            />
                        </div>
                    </div>
                    <Divider />
                    <h5>Apariencia</h5>
                    <Divider />
                    <h5>Lista de teclas rápidas (shortcuts)</h5>
                    {renderShortcuts()}
                    <Divider />
                    <h5>Preferencias</h5>
                    <div className={styles.row}>
                        <span>Presionar </span>
                        <ButtonKey>Enter</ButtonKey>
                        <span> para enviar →</span>
                        <Toggle
                            default={sendOnEnter}
                            onToggle={() => toggleSendOnEnter()}
                        />

                        <span>{sendOnEnter ? 'Activado' : 'Desactivado'}</span>
                    </div>
                </section>
            </div>
        </View>
    );
};

export default SettingsView;
